export default __webpack_public_path__ + "static/media/executive.05d3deb3.png";